import { VARIANT_SELF_EMPLOYED_PLATFORM, VARIANT_SELF_EMPLOYED_SUBSCRIPTION } from '@/constants'
import { useProfile } from '@/store/profile'

import { useIsReturningSelfEmployedCustomer } from '../profile'

// Determine if we should display the platform onboarding
const useShouldDisplaySelfEmployedPlatformOnboarding = () => {
    const { profile } = useProfile()
    const { variant } = profile

    return variant === VARIANT_SELF_EMPLOYED_PLATFORM
}

// Determine if we should display the subscription onboarding
const useShouldDisplaySelfEmployedSubscriptionOnboarding = () => {
    const { profile } = useProfile()
    const { variant } = profile

    return variant === VARIANT_SELF_EMPLOYED_SUBSCRIPTION
}

// Determine if we should display the platform promotions to existing users
const useShouldDisplaySelfEmployedPlatformPromotions = () => {
    const { profile } = useProfile()
    const { selfEmployedPlatformEnabled } = profile

    const isReturningSelfEmployedCustomer = useIsReturningSelfEmployedCustomer()

    if (selfEmployedPlatformEnabled) return false

    return isReturningSelfEmployedCustomer
}

// Determine if we should display the platform
const useShouldDisplaySelfEmployedPlatform = () => {
    const { profile } = useProfile()
    const { selfEmployedPlatformEnabled } = profile

    const shouldDisplaySelfEmployedPlatformOnboarding = useShouldDisplaySelfEmployedPlatformOnboarding()
    const shouldDisplaySelfEmployedSubscriptionOnboarding = useShouldDisplaySelfEmployedSubscriptionOnboarding()
    const shouldDisplaySelfEmployedPlatformPromotions = useShouldDisplaySelfEmployedPlatformPromotions()

    if (selfEmployedPlatformEnabled) return true

    return (
        shouldDisplaySelfEmployedPlatformOnboarding ||
        shouldDisplaySelfEmployedSubscriptionOnboarding ||
        shouldDisplaySelfEmployedPlatformPromotions
    )
}

export const useSelfEmployedPlatformVisibility = () => {
    const shouldDisplaySelfEmployedPlatform = useShouldDisplaySelfEmployedPlatform()
    const shouldDisplaySelfEmployedPlatformOnboarding = useShouldDisplaySelfEmployedPlatformOnboarding()
    const shouldDisplaySelfEmployedSubscriptionOnboarding = useShouldDisplaySelfEmployedSubscriptionOnboarding()
    const shouldDisplaySelfEmployedPlatformPromotions = useShouldDisplaySelfEmployedPlatformPromotions()

    return {
        shouldDisplaySelfEmployedPlatform,
        shouldDisplaySelfEmployedPlatformOnboarding,
        shouldDisplaySelfEmployedPlatformPromotions,
        shouldDisplaySelfEmployedSubscriptionOnboarding,
    }
}
